import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';

import { PropertiesService } from '../services/properties.service';

import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class RequestCache {

	
	constructor(
		private propertiesService : PropertiesService
	) { }

	maxAge = 5*60*1000;

	cache = new Map();

	get(req : HttpRequest<any>) : HttpResponse<any> | undefined {

		let url = req.urlWithParams;
		let request = this.cache.get(url);

		if(request){
			if(request.timestamp < (Date.now() - this.maxAge)){
				this.cache.delete(url);
				return undefined;
			}else {
				return request.response;
			}
		}

		return undefined;
	}

	put(req : HttpRequest<any>, res : HttpResponse<any>) : void {
		let url = req.urlWithParams;
		this.cache.set(url, {
			response : res,
			timestamp : Date.now()
		});
	}

	delete(url : string) : void {
		this.cache.delete(this.propertiesService.getProp('apiPrefix')+url);
	}

	deleteAll() : void {
		this.cache = new Map();
	}

}

@Injectable()
export class CachingInterceptor implements HttpInterceptor{


	public pathToCache:string[] = [
		"/Servizi/TipologieAllegato'",
		"/api/Servizi/DimensioneMassimaAllegato",
		"/Edizione/InfoCorrente",
		"/Servizi/Linguaggio?id=",
		"/Servizi/Errori?id=",
		"/Servizi/ListaLinguaggi",
		"/api/Servizi/ListaRegioni",
		"/api/Public/Edizione/RegolamentoCorrente",
		"/api/Public/Edizione/LogoEdizione",
		"/api/Public/Servizi/ListaNazioni",
		"NumeroNodi"];

	constructor(private cache: RequestCache) {}
	
	send(req: HttpRequest<any>, next : HttpHandler) {
		let request = req.clone();
		return next.handle(request).pipe(
			tap(event => {
				if(event instanceof HttpResponse){
					var toCache = false;
					for(var i = 0; i < this.pathToCache.length; i++)
					{
						if(req.url.indexOf(this.pathToCache[i]) > -1){
							toCache = true;
							break;
						}
					}
					if(toCache)
						this.cache.put(req, event);
				}
			})
		);
	}

	intercept(req: HttpRequest<any>, next : HttpHandler){

		var isResetCache = false;
		if(req.url.indexOf("RicaricaCache") > -1){
			isResetCache = true;
		}
		const authReq = req.clone({
			url : isResetCache ? req.url.replace("https", "http") : req.url
		});

		if(req.method !== "GET"){
			return next.handle(req);
		}else {
			let cached = this.cache.get(req);
			return cached ? of(cached) : this.send(authReq, next);
		}
	}


}